<template>
  <div class="markdown-preview">
    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else v-html="renderedContent"></div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

export default {
  name: 'MarkdownPreview',
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      md: null,
      markdownContent: '',
      loading: true,
      error: null
    }
  },
  computed: {
    renderedContent() {
      if (!this.markdownContent || !this.md) return ''
      try {
        return this.md.render(this.markdownContent)
      } catch (err) {
        return ''
      }
    }
  },
  created() {
    // 初始化markdown-it
    this.md = new MarkdownIt({
      html: true,
      linkify: true,
      typographer: true,
      breaks: true
    })
    
    // 获取Markdown内容
    this.fetchMarkdownContent()
  },
  watch: {
    markdownContent: {
      handler(newVal) {
        if (newVal && this.md) {
          try {
            // 测试渲染是否成功
            this.md.render(newVal)
            this.error = null
          } catch (err) {
            this.error = `渲染错误: ${err.message}`
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    
    async fetchMarkdownContent() {
      try {
        this.loading = true
        this.error = null
        
        let actualUrl = this.url;
        
        // 检查是否是base64编码的URL
        if (this.url && this.url.length > 100) {
          try {
            // 解码base64 URL
            actualUrl = atob(this.url);
            console.log('解码后的URL:', actualUrl);
          } catch (e) {
            console.error('URL解码失败:', e);
            actualUrl = this.url;
          }
        }
        console.log("+++++++++++++++++++++response start:")
        // 获取内容
        const response = await this.$http.get(actualUrl, {
            headers: {
                'Accept': 'text/plain, text/markdown, text/html',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        console.log("+++++++++++++++++++++response:",response)
        if (response.status === 200 && response.data) {
          this.markdownContent = response.data
        } else {
          throw new Error('获取内容失败')
        }
      } catch (err) {
        this.error = `加载失败: ${err.message}`
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
/* GitHub风格的Markdown样式 */
.markdown-preview {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  word-wrap: break-word;
  padding: 16px;
  background-color: #ffffff;
  color: #24292e;
}

.markdown-preview h1,
.markdown-preview h2,
.markdown-preview h3,
.markdown-preview h4,
.markdown-preview h5,
.markdown-preview h6 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 1.25;
}

.markdown-preview h1 {
  font-size: 2em;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3em;
}

.markdown-preview h2 {
  font-size: 1.5em;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3em;
}

.markdown-preview h3 {
  font-size: 1.25em;
}

.markdown-preview h4 {
  font-size: 1em;
}

.markdown-preview h5 {
  font-size: 0.875em;
}

.markdown-preview h6 {
  font-size: 0.85em;
  color: #6a737d;
}

.markdown-preview p {
  margin-top: 0;
  margin-bottom: 16px;
}

.markdown-preview blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
  margin: 0 0 16px 0;
}

.markdown-preview ul,
.markdown-preview ol {
  padding-left: 2em;
  margin-top: 0;
  margin-bottom: 16px;
}

.markdown-preview li {
  margin-top: 0.25em;
}

.markdown-preview code {
  padding: 0.2em 0.4em;
  margin: 0;
  font-size: 85%;
  background-color: rgba(27, 31, 35, 0.05);
  border-radius: 3px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
}

.markdown-preview pre {
  padding: 16px;
  overflow: auto;
  font-size: 85%;
  line-height: 1.45;
  background-color: #f6f8fa;
  border-radius: 3px;
  margin-top: 0;
  margin-bottom: 16px;
}

.markdown-preview pre code {
  padding: 0;
  margin: 0;
  font-size: 100%;
  word-break: normal;
  white-space: pre;
  background: transparent;
  border: 0;
}

.markdown-preview table {
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
}

.markdown-preview table th,
.markdown-preview table td {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

.markdown-preview table th {
  font-weight: 600;
  background-color: #f6f8fa;
}

.markdown-preview table tr:nth-child(2n) {
  background-color: #f6f8fa;
}

.markdown-preview img {
  max-width: 100%;
  box-sizing: content-box;
}

.markdown-preview a {
  color: #0366d6;
  text-decoration: none;
}

.markdown-preview a:hover {
  text-decoration: underline;
}

.markdown-preview hr {
  height: 0.25em;
  padding: 0;
  margin: 24px 0;
  background-color: #e1e4e8;
  border: 0;
}

.markdown-preview strong {
  font-weight: 600;
}

.markdown-preview em {
  font-style: italic;
}

.markdown-preview del {
  text-decoration: line-through;
}

/* 加载和错误状态样式 */
.loading {
  text-align: center;
  padding: 40px;
  color: #6a737d;
  font-size: 16px;
}

.error {
  background-color: #ffeef0;
  border: 1px solid #f97583;
  border-radius: 3px;
  padding: 16px;
  margin: 16px;
  color: #d73a49;
}
</style> 